
import { LocalStorageService } from "../shared/services/localstorage.service";
import { PermissionDto } from "./modals/dashboard/permissionDto";

export let pageName = '';

export class BaseComponent {

  SetPageName(str = '') {
    document.getElementsByTagName('title')[0].innerHTML =
      document.getElementsByTagName('title')[0].innerHTML == '' ? str : document.getElementsByTagName('title')[0].innerHTML;
    this.SetMenu();
    if (str != '') {
      return str;
    }
    else {
      return document.getElementsByTagName('title')[0].innerHTML;
    }
  }

  SetMenu() {
    // let self = document.getElementById(taskId);
    const taskId = localStorage.getItem('Task');
    if (taskId != undefined) {
      const isparent = false;
      let self = document.querySelector(`[id="${taskId}"]:not(.has-sub)`);
      Array.from(document.getElementsByClassName('open')).forEach(e => {
        e.classList.remove('open')
      })
      if (self) {
        while (!(self.parentNode as HTMLElement).classList.contains('rootul')) {
          self.tagName == 'LI';
          self.classList.add('open');
          self = (self.parentNode!.parentNode as HTMLElement);
        }

        self.classList.add('open')
      }
    }
  }

  static SetPageMenu() {
    const taskId = localStorage.getItem('Task');
    if (taskId != undefined) {
      const isparent = false;
      let self = document.getElementById(taskId);
      Array.from(document.getElementsByClassName('open')).forEach(e => {
        e.classList.remove('open')
      })
      if (self) {
        while (!(self.parentNode as HTMLElement).classList.contains('rootul')) {
          self.tagName == 'LI';
          self.classList.add('open');
          self = (self.parentNode!.parentNode as HTMLElement);
        }
        self.classList.add('open')
      }
    }
  }

  calculateDateValue(dateAdapter: any, ngbCalendar: any, numberOfDays: number): any {
    const toDateValue = dateAdapter.toModel(ngbCalendar.getToday())!;
    const fromDateValue = dateAdapter.toModel(ngbCalendar.getPrev(toDateValue, 'd', numberOfDays))!;
    return { toDateValue, fromDateValue };
  }


}

const s4 = Math.floor((1 + Math.random()) * 0x10000)
  .toString(16)
  .substring(1);

export class DateExtension {

  static getTodayDate() {
    const date = new Date();
    const year =  date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const dateObj = { year, month, day };
    return dateObj;
  }

  static getWeekRangeDate() {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const dateObj = { year, month, day };
    return dateObj;
  }

  static getMonthRangeDate() {
    const date = new Date();
    const year = date.getFullYear();
    date.setMonth(date.getMonth() - 1)
    const month = date.getMonth() + 1
    const day = date.getDate();
    const dateObj = { year: month === 12 ? year - 1 : year, month, day };
    return dateObj;
  }


  static ToString(dt: Date, format: string) {

    const mnthary = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const dd = NumberExtension.PadNum(dt.getDate(), '0', 2);
    const MM = NumberExtension.PadNum(dt.getMonth() + 1, '0', 2);
    const MMM = mnthary[dt.getMonth()];
    const yyyy = dt.getFullYear().toString();
    const HH = NumberExtension.PadNum(dt.getHours(), '0', 2);
    const hh = StringExtension.ToInt(HH) >= 12 ? (StringExtension.ToInt(HH) - 12).toString() : HH.toString();
    const min = NumberExtension.PadNum(dt.getMinutes(), '0', 2);
    return format.replace('dd', dd).replace('MMM', MMM).replace('MM', MM).replace('yyyy', yyyy).replace('HH', HH)
      .replace('hh', StringExtension.ToInt(hh) > 10 ? hh.toString() : (hh.length === 2 ? hh : '0' + hh).toString()).replace('mm', min);
  }

  static ToDate(dt: string, fromFormat: string, sep: string) {
    const mnthary = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    // fromFormat
    const ffdt = fromFormat.split(' ')[0];
    const fftm = fromFormat.split(' ').length > 1 ? fromFormat.split(' ')[1] : '';
    const fftt = fromFormat.split(' ').length > 2 ? fromFormat.split(' ')[2] : '';

    const vfdt = dt.split(' ')[0];
    const vftm = dt.split(' ').length > 1 ? dt.split(' ')[1] : '';
    const vftt = dt.split(' ').length > 2 ? dt.split(' ')[2] : '';

    const idd = ffdt.split(sep).findIndex(e => e === 'dd');
    const iMM = ffdt.split(sep).findIndex(e => e === 'MM'); // starts from 1
    // const imm = ffdt.split(sep).findIndex(e => e === 'mm'); // starts from 0
    const iMMM = ffdt.split(sep).findIndex(e => e === 'MMM'); // short form
    const iyyyy = ffdt.split(sep).findIndex(e => e === 'yyyy');
    const iHH = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'HH') : -1;
    const ihh = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'hh') : -1;
    const imin = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'mm') : -1;
    const iss = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'ss') : -1;
    const itt = fftt;
    const dd = StringExtension.ToInt(vfdt.split(sep)[idd]);
    const mm = iMM >= 0 ? (StringExtension.ToInt(vfdt.split(sep)[iMM]) - 1) : mnthary.indexOf(vfdt.split(sep)[iMMM]);

    const yyyy = StringExtension.ToInt(vfdt.split(sep)[iyyyy]);
    let hh = 0;
    let min = 0;
    if (!StringExtension.IsNullOrWhiteSpace(vftm)) {
      hh = iHH >= 0 ? StringExtension.ToInt(vftm.split(':')[iHH]) : (ihh >= 0) ?
        (vftt.toLowerCase() === 'pm' ? StringExtension.ToInt(vftm.split(':')[ihh]) + 12 : StringExtension.ToInt(vftm.split(':')[ihh])) : 0;
      min = StringExtension.ToInt(vftm.split(':')[imin]);
    }

    return new Date(yyyy, mm - 1, dd, hh, min);

  }

  static Map(dt: string, fromFormat: string, toFormat: string, sep: string, isString: boolean = true) {
    const mnthary = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    if (fromFormat.indexOf('T') > 0) {
      dt = dt.replace('T', ' ');
      fromFormat = fromFormat.replace('T', ' ');
    }
    // fromFormat
    const ffdt = fromFormat.split(' ')[0];
    const fftm = fromFormat.split(' ').length > 1 ? fromFormat.split(' ')[1] : '';
    const fftt = fromFormat.split(' ').length > 2 ? fromFormat.split(' ')[2] : '';

    const vfdt = dt.split(' ')[0];
    const vftm = dt.split(' ').length > 1 ? dt.split(' ')[1] : '';
    const vftt = dt.split(' ').length > 2 ? dt.split(' ')[2] : '';

    const idd = ffdt.split(sep).findIndex(e => e === 'dd');
    const iMM = ffdt.split(sep).findIndex(e => e === 'MM'); // starts from 1
    // const imm = ffdt.split(sep).findIndex(e => e === 'mm'); // starts from 0
    const iMMM = ffdt.split(sep).findIndex(e => e === 'MMM'); // short form
    const iyyyy = ffdt.split(sep).findIndex(e => e === 'yyyy');
    const iHH = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'HH') : -1;
    const ihh = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'hh') : -1;
    const imin = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'mm') : -1;
    const iss = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'ss') : -1;
    const itt = fftt;
    const dd = StringExtension.ToInt(vfdt.split(sep)[idd]);
    const mm = iMM >= 0 ? (StringExtension.ToInt(vfdt.split(sep)[iMM]) - 1) : mnthary.indexOf(vfdt.split(sep)[iMMM]);

    const yyyy = StringExtension.ToInt(vfdt.split(sep)[iyyyy]);
    let hh = 0;
    let min = 0;
    if (!StringExtension.IsNullOrWhiteSpace(vftm)) {
      hh = iHH >= 0 ? StringExtension.ToInt(vftm.split(':')[iHH]) : (ihh >= 0) ?
        (vftt.toLowerCase() === 'pm' ? StringExtension.ToInt(vftm.split(':')[ihh]) + 12 : StringExtension.ToInt(vftm.split(':')[ihh])) : 0;
      min = StringExtension.ToInt(vftm.split(':')[imin]);
    }

    hh = isNaN(hh) ? 0 : hh;
    min = isNaN(min) ? 0 : min;

    const FromDate = new Date(yyyy, mm, dd, hh, min);
    const hour = StringExtension.ToInt(NumberExtension.PadNum(FromDate.getHours(), '0', 2));
    return isString ? toFormat.replace('dd', (NumberExtension.PadNum(FromDate.getDate(), '0', 2)))
      .replace('MMM', mnthary[FromDate.getMonth()])
      .replace('MM', (NumberExtension.PadNum((FromDate.getMonth() + 1), '0', 2)))
      .replace('yyyy', FromDate.getFullYear().toString())
      .replace('hh', (hour > 11 ? (NumberExtension.PadNum((hour == 12 ? hour : (hour - 12)), '0', 2)) : (NumberExtension.PadNum((hour == 0 ? 12 : hour), '0', 2))))
      .replace('HH', (NumberExtension.PadNum(hour, '0', 2)))
      .replace('mm', NumberExtension.PadNum(FromDate.getMinutes(), '0', 2))
      .replace('tt', (hour > 11 ? 'pm' : 'am')).replace('TT', (hour > 11 ? 'PM' : 'AM'))
      : toFormat.replace('dd', FromDate.getDate().toString())
        .replace('MMM', mnthary[FromDate.getMonth()])
        .replace('MM', (FromDate.getMonth() + 1).toString())
        .replace('yyyy', FromDate.getFullYear().toString())
        .replace('hh', (hour > 11 ? (hour == 12 ? hour : (hour - 12)).toString() : (hour == 0 ? 12 : hour).toString()))
        .replace('HH', hour.toString())
        .replace('mm', FromDate.getMinutes().toString())
        .replace('tt', (hour > 11 ? 'pm' : 'am')).replace('TT', (hour > 11 ? 'PM' : 'AM'));


  }

  static APItoUI(dt: string) {
    return DateExtension.Map(dt, 'MM-dd-yyyy HH:mm', 'dd-MMM-yyyy hh:mm tt', '-');
  }

  static UItoAPI(dt: string) {
    return DateExtension.Map(dt, 'dd-MMM-yyyy hh:mm tt', 'MM-dd-yyyy HH:mm', '-') + ':00';
  }

  static APIToUIGrid(dt: string) {
    const date = dt.split('T')[0].split('-');
    return date[2] + '/' + date[1] + '/' + date[0];
  }

  static APIToUIBind(dt: string) {
    const date = dt.split('T')[0].split('-');
    return { year: Number(date[0]), month: Number(date[1]), day: Number(date[2]) }
  }

  static MapTime(dt: string, fromFormat: string, toFormat: string, sep: string) {
    const fftm = fromFormat.split(' ').length > 1 ? fromFormat.split(' ')[0] : '';
    const fftt = fromFormat.split(' ').length >= 2 ? fromFormat.split(' ')[1] : '';

    const vftm = dt.split(' ').length > 1 ? dt.split(' ')[0] : '';
    const vftt = dt.split(' ').length >= 2 ? dt.split(' ')[1] : '';

    const iHH = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'HH') : -1;
    const ihh = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'hh') : -1;
    const imin = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'mm') : -1;
    const iss = !StringExtension.IsNullOrWhiteSpace(fftm) ? fftm.split(':').findIndex(e => e === 'ss') : -1;

    let hh = 0;
    let min = 0;
    if (!StringExtension.IsNullOrWhiteSpace(vftm)) {
      hh = iHH >= 0 ? StringExtension.ToInt(vftm.split(':')[iHH]) : (ihh >= 0) ?
        (vftt.toLowerCase() === 'pm' ? StringExtension.ToInt(vftm.split(':')[ihh]) + 12 :
          StringExtension.ToInt(vftm.split(':')[ihh])) : 0;
      min = StringExtension.ToInt(vftm.split(':')[imin]);
    }

    const FromDate = new Date(hh, min);
    const hour = hh;
    return toFormat.replace('hh', (hour > 11 ? (NumberExtension.PadNum((hour - 12), '0', 2)) : (NumberExtension.PadNum(hour, '0', 2))))
      .replace('HH', (NumberExtension.PadNum(hour, '0', 2)))
      .replace('mm', NumberExtension.PadNum(min, '0', 2))
      .replace('tt', (hour > 11 ? 'pm' : 'am')).replace('TT', (hour > 11 ? 'PM' : 'AM'));
  }

  static UItoAPITime(dt: string) {
    return DateExtension.MapTime(dt, 'hh:mm tt', 'HH:mm', '-') + ':00.0000000';
  }

  static getMaxDate(yr: number = 20) {
    return new Date(yr, 1, 1, 0, 0, 0);
  }

  static getMaxDateStr(format: string, yr: number = 20) {
    return format.replace('yyyy', (new Date().getFullYear() + 20).toString())
      .replace('yy', (new Date().getFullYear() + 20).toString().substring(2)).replace('MM', '01').replace('dd', '01')
      .replace('HH', '00').replace('mm', '00').replace('ss', '00');
  }

  static getMinDate() {
    return new Date(1900, 1, 1, 0, 0, 0);
  }

  static getMinDateStr(format: string) {
    return format.replace('yyyy', '1900')
      .replace('yy', '00').replace('MM', '01').replace('dd', '01')
      .replace('HH', '00').replace('mm', '00').replace('ss', '00');
  }

  static getObjectToString(format: string, dt: any, isMin: boolean, yr: number = 20) {
    let dtstr = dt == '' || dt == null ? (isMin ? this.getMinDateStr(format) : this.getMaxDateStr(format, yr)) : format.replace('yyyy', (dt.year).toString())
      .replace('yy', (dt.year).toString().substring(2)).replace('MM', (dt.month < 10 ? '0' + dt.month : dt.month)).replace('dd', (dt.day < 10 ? '0' + dt.day : dt.day))
      .replace('HH', '00').replace('mm', '00').replace('ss', '00');
    return dtstr;
  }

  static convertDateFormate(dt:string | Date){
    let bindDate = JSON.parse(JSON.stringify(dt.toLocaleString().slice(0, 10).split('-')))
    bindDate = {
      year: Number(bindDate[0]),
      month: Number(bindDate[1]),
      day: Number(bindDate[2])
    };
    return bindDate;
  }

  static convertDatetoObject(date: any) {
    const dateObj = new Date(date);
    const outputDateObj = {
      day: dateObj.getDate(),
      month: dateObj.getMonth() + 1,
      year: dateObj.getFullYear(),
    };
    return outputDateObj;
  }
}

export class NumberExtension {
  static PadNum(val: string | number, padd: string, count: number): string {
    let value = '';
    value = typeof (val) === 'number' ? val.toString() : val;
    for (let index = 0; index < (count - value.length); index++) {
      value = padd + value;
    }
    return value;
  }
}

export class StringExtension {
  static IsNullOrWhiteSpace(s: any) {
    return ((s !== undefined && s != null && (typeof (s) !== 'string' ? s.toString() : s).trim() !== '') ? false : true);
  }
  static Guid() {
    return s4 + s4 + '-' + s4 + '-' + s4 + '-' + s4 + '-' + s4 + s4 + s4;
  }
  static ToInt(s: any) {
    return parseInt(s, 10);
  }
  static ToFloat(s: any) {
    return parseFloat(s);
  }
  static ToFixedDecimal(s: any, digit: any) {
    // let a = parseFloat('7.' + (s).toString().split('.')[1]) - 7;
    return parseFloat(s.toFixed(digit));
  }
  // static ToFixed(a, d) {
  //   // var a = parseFloat('7.' + (s).toString().split('.')[1]) - 7;
  //   // return Math.floor(s) + parseFloat(a.toFixed(digit));

  //   let t = a.toString().split('.')[1];
  //   if (t === undefined) {
  //     t = '00';
  //   }
  //   while (t.length > d) {
  //     t = parseInt(t[t.length - 1], 10) < 5 ? t.substring(0, t.length - 1) : (parseInt(t.substring(0, t.length - 1), 10) + 1).toString();
  //   }
  //   return parseFloat(a.toString().split('.')[0] + '.' + t);
  // }
  static ToFixed(a: any, d: any) {
    // var a = parseFloat('7.' + (s).toString().split('.')[1]) - 7;
    // return Math.floor(s) + parseFloat(a.toFixed(digit));

    //let t = a.toString().split('.')[1]; /// 17.9456
    //if (t === undefined) {
    //  t = '00';
    //}
    ////debugger;
    ////t = t.substring(0, d + 1);
    //while (t.length > d) {

    //  t = parseInt(t[t.length - 1], 10) < 5 ? t.substring(0, t.length - 1) : (parseInt(t.substring(0, t.length - 1), 10) + 1).toString();
    //}
    //return parseFloat(a.toString().split('.')[0] + '.' + t);
    return Math.round((a + 0.00001) * 100) / 100;
  }
}

export class GetPermission{
  private static permission: PermissionDto[] = [];
  
  static compareTaskId(screenTaskId: number):PermissionDto | undefined {
    const localStorage = new LocalStorageService();
    if (this.permission.length === 0) {
      this.permission = localStorage.getLocalData('permission')
    }
    return (this.permission.find(x => x.taskID === screenTaskId));
  }

  static clear(){
    this.permission = [];
  }

}

export class Localization {
  static DateFormat = 'dd-MM-yyyy'
}